import { PaymentModes } from '../constants';
import formatCreditCardPaymentRequest from './formatCreditCardPaymentRequest';

/**
 * Builds credit card payments array for booking (multiple cards)
 * @param {Object} params - Parameters for building payments
 * @param {boolean} params.doIncludeCC - Whether to include credit cards
 * @param {Object} params.paymentMethods - Available credit cards
 * @param {Object} params.tokenizedCardMap - Tokenized card data map
 * @param {boolean} params.isLoggedIn - User login status
 * @returns {Array|undefined} Array of formatted credit card payments or undefined
 */
export const buildCreditCardPayments = (params) => {
  const { doIncludeCC, paymentMethods, tokenizedCardMap, isLoggedIn } = params;

  if (!doIncludeCC) {
    return undefined;
  }

  // Handle tokenized cards
  if (tokenizedCardMap && Object.keys(tokenizedCardMap).length > 0) {
    const pickedEntries = Object.entries(paymentMethods).filter(([, card]) => card.isPicked);
    const cardsToUse =
      pickedEntries.length > 0 ? pickedEntries : Object.entries(paymentMethods).slice(0, 1);

    if (cardsToUse.length === 0) {
      return undefined;
    }

    return cardsToUse.map(([index, card]) => {
      const tokenPayload = tokenizedCardMap[index];
      if (!tokenPayload && (!card || card.paymentMode === PaymentModes.NEW_CREDIT_CARD)) {
        throw new Error('Missing tokenized data for one of the credit cards.');
      }
      return formatCreditCardPaymentRequest(
        { ...card, creditCard: { ...tokenPayload } },
        card,
        isLoggedIn,
      );
    });
  }

  // Handle non-tokenized cards
  const pickedCards = Object.values(paymentMethods).filter((card) => card.isPicked);

  if (pickedCards.length === 0) {
    return undefined;
  }

  return pickedCards.map((card) => formatCreditCardPaymentRequest(card, card, isLoggedIn));
};

export default buildCreditCardPayments;
